export default __webpack_public_path__ + "static/media/comptabilite.ec05023c.png";